import type { Step } from '../types/step';

export const FinishedStep: Step = {
  id: 'finished',
  pathname: '/finish',
  canShow: () => true,
  hasData: () => true,
  hasOwnData: () => true,
};
